var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c("d2-mde", {
        staticClass: "mde",
        model: {
          value: _vm.text,
          callback: function($$v) {
            _vm.text = $$v
          },
          expression: "text"
        }
      }),
      _c("el-card", { staticClass: "d2-card", attrs: { shadow: "never" } }, [
        _c("pre", [_vm._v(_vm._s(_vm.text))])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }